import React, { useEffect, useState } from 'react';
import { getFullNameOrEmail } from '../../../redux/user';
import Card from '@mui/material/Card';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { standardDateFormat } from '../../../helpers/date';
import { getTrainingName, getCustomersById } from './utils';
import dayjs from 'dayjs'

const TrainingDue = (props) => {
  const { customers, complianceStatus, message } = props

  const [rows, setRows] = useState([]);

  useEffect(() => {
    const customersById = getCustomersById(customers)
    const userTrainings = customers.flatMap(customer => customer.users_training)
    const dueTrainings = userTrainings.filter(userTraining => userTraining.compliance_status === complianceStatus)

    const rows = dueTrainings.map(userTraining => {
      const customer = customersById.get(userTraining.customer_number)
      const userName = getFullNameOrEmail(userTraining.user)
      const year = userTraining.training?.year

      const row = {
        practiceName: customer.name,
        userName: userName,
        courseName: getTrainingName(userTraining),
        dueDate: standardDateFormat(userTraining.due_date),
        timestamp: dayjs(userTraining.due_date).valueOf(),
        year: year ?? '',
      }

      return row
    })

    rows.sort((a, b) => {
      if (a.practiceName !== b.practiceName) {
        return a.practiceName.localeCompare(b.practiceName)
      }

      if (a.timestamp !== b.timestamp) {
        return a.timestamp - b.timestamp
      }

      return a.userName.localeCompare(b.userName)
    })

    setRows(rows)
  }, [ customers ]);

  return (
    <Card variant="outlined">
      <div className="box-header">
        {rows.length} Result{rows.length > 1 ? 's' : ''}
      </div>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Practice Name</TableCell>
            <TableCell>Name</TableCell>
            <TableCell>Year</TableCell>
            <TableCell>Course Name</TableCell>
            <TableCell>Due Date</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, index) => {
            return (
              <TableRow key={index}>
                <TableCell>{row.practiceName}</TableCell>
                <TableCell>{row.userName}</TableCell>
                <TableCell>{row.year}</TableCell>
                <TableCell>{row.courseName}</TableCell>
                <TableCell>{row.dueDate}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
      {rows.length === 0 && (
        <div className='p-16 center'>
          { message }
        </div>
      )}
    </Card>
  );
}

export default TrainingDue;
